import React from 'react'

export function getPillBackground(isOn, disabled, activeColor = '#1976d2') {
  if (disabled) return '#ccc'
  return isOn ? activeColor : '#bbb'
}

/**
 * The pill shape shared by toggle components.
 *
 * Props:
 *   isOn         {boolean}
 *   background   {string}   - pill background color (use getPillBackground)
 *   width        {number}
 *   height       {number}
 *   borderRadius {number}
 *   thumbSize    {number}
 *   thumbOnLeft  {number}   - left offset of thumb when ON
 *   showOnOff    {boolean}  - render ON/OFF text inside the pill
 */
export function TogglePill({ isOn, background, width, height, borderRadius, thumbSize, thumbOnLeft, showOnOff }) {
  return (
    <div style={{
      position: 'relative',
      width,
      height,
      borderRadius,
      flexShrink: 0,
      background,
      transition: 'background 0.2s',
    }}>
      {showOnOff && (
        <span style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: '0.05em',
          color: 'white',
          userSelect: 'none',
          pointerEvents: 'none',
          left: isOn ? 8 : undefined,
          right: isOn ? undefined : 8,
        }}>
          {isOn ? 'ON' : 'OFF'}
        </span>
      )}
      <div style={{
        position: 'absolute',
        top: 3,
        left: isOn ? thumbOnLeft : 3,
        width: thumbSize,
        height: thumbSize,
        borderRadius: '50%',
        background: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        transition: 'left 0.2s',
      }} />
    </div>
  )
}
